import useAsync from './useAsync';
import passengerTypeStore from 'Models/PassengerTypeStore';

/**
 * Call this hook in your component for a re-render when add on store finishes fetching data.
 */
export default function usePassengerTypes(refresh: boolean = false) {
	return useAsync(() => passengerTypeStore.retrieveAsync(refresh), []);
}
